// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mBwH","type":"styles_type__3lni4","choices":"styles_choices__2HrXw"};